(() => {
 function init(root=document){
  root.querySelectorAll('[data-sw-products]').forEach(section=>{
   if(section.dataset.ready)return;section.dataset.ready='true';
   let group='all';const search=section.querySelector('[data-sw-search]');
   function filter(){let count=0;const q=(search?.value||'').toLocaleLowerCase('de').trim();
    section.querySelectorAll('[data-sw-group]').forEach(card=>{card.hidden=(group!=='all'&&card.dataset.swGroup!==group)||!card.dataset.swTitle.includes(q);if(!card.hidden)count++});
    section.querySelector('.sw-empty').hidden=count>0;
   }
   section.querySelectorAll('[data-sw-filter]').forEach(b=>b.addEventListener('click',()=>{
    group=b.dataset.swFilter;section.querySelectorAll('[data-sw-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));filter();
   }));search?.addEventListener('input',filter);
  });
 }
 init();document.addEventListener('shopify:section:load',()=>init());
 // Preserve the original AJAX cart but keep the new compact badge truthful.
 if(window.jQuery)window.jQuery(document.body).on('ajaxCart.afterCartLoad',(_event,cart)=>{
  document.querySelectorAll('.sw-cart-count').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0});
 });
})();
